var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "merchant-info-setting" },
    [
      _c("div", { staticClass: "sectionItem" }, [
        _c("div", { staticClass: "sectionItem_title" }, [
          _vm._v(_vm._s(_vm.$t("merchant.merchant_basic_info"))),
        ]),
        _c(
          "div",
          [
            _c(
              "el-row",
              { staticClass: "sectionItem_name" },
              [
                _c(
                  "el-col",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.uploadLoading,
                        expression: "uploadLoading",
                      },
                    ],
                    staticClass: "sectionItem_col",
                    staticStyle: { height: "90px" },
                    attrs: { span: 24 },
                  },
                  [
                    _c("div", { staticStyle: { display: "inline-block" } }, [
                      _c("span", { staticClass: "sectionItem_col-label" }, [
                        _vm._v(_vm._s(_vm.$t("merchant.merchant_logo")) + "："),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticStyle: { display: "inline-block" } },
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "head-img-upload",
                            class: { hideUploadFlag: _vm.isHideUpdate },
                            attrs: {
                              action: "#",
                              "list-type": "picture-card",
                              "auto-upload": false,
                              "file-list": _vm.fileList,
                              accept: ".jpg,.jpeg,.png,.JPG,.JPEG,.PNG",
                              limit: 1,
                              "on-change": _vm.handleImageChange,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "file",
                                fn: function (ref) {
                                  var file = ref.file
                                  return _c("div", {}, [
                                    _c("img", {
                                      staticClass:
                                        "el-upload-list__item-thumbnail",
                                      staticStyle: {
                                        width: "80px",
                                        height: "80px",
                                      },
                                      attrs: { src: file.url, alt: "" },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "el-upload-list__item-actions",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "el-upload-list__item-preview",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handlePictureCardPreview(
                                                  file
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-zoom-in",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                },
                              },
                            ]),
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-plus",
                              attrs: { slot: "default" },
                              slot: "default",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm.userInfo.merchant_basic_info.logo_img
                      ? _c(
                          "div",
                          { staticStyle: { display: "inline-block" } },
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "head-img-upload-btn",
                                attrs: {
                                  action: "#",
                                  "list-type": "picture-card",
                                  "auto-upload": false,
                                  "show-file-list": false,
                                  accept: ".jpg,.jpeg,.png,.JPG,.JPEG,.PNG",
                                  "file-list": _vm.fileList,
                                  "on-change": _vm.handleImageChange,
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-edit update-head-img",
                                }),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
                _c(
                  "el-col",
                  { staticClass: "sectionItem_col", attrs: { span: 12 } },
                  [
                    _c("span", { staticClass: "sectionItem_col-label" }, [
                      _vm._v(_vm._s(_vm.$t("merchant.merchant_name")) + "："),
                    ]),
                    _vm._v(_vm._s(_vm.userInfo.merchant_name) + " "),
                  ]
                ),
                _c(
                  "el-col",
                  { staticClass: "sectionItem_col", attrs: { span: 12 } },
                  [
                    _c("span", { staticClass: "sectionItem_col-label" }, [
                      _vm._v(_vm._s(_vm.$t("merchant.merchant_no")) + "："),
                    ]),
                    _vm._v(_vm._s(_vm.userInfo.merchant_no) + " "),
                  ]
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { staticClass: "sectionItem_name" },
              [
                _c(
                  "el-col",
                  { staticClass: "sectionItem_col", attrs: { span: 12 } },
                  [
                    _c("span", { staticClass: "sectionItem_col-label" }, [
                      _vm._v(_vm._s(_vm.$t("merchant.merchant_type")) + "："),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getMerchantTypeMap(_vm.userInfo.merchant_type)
                        )
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { staticClass: "sectionItem_name" },
              [
                _c(
                  "el-col",
                  { staticClass: "sectionItem_col", attrs: { span: 12 } },
                  [
                    _c("span", { staticClass: "sectionItem_col-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("merchant.notification_email")) + "："
                      ),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.userInfo.merchant_basic_info.notification_email
                        )
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { staticClass: "sectionItem_name" },
              [
                _c(
                  "el-col",
                  { staticClass: "sectionItem_col", attrs: { span: 12 } },
                  [
                    _c("span", { staticClass: "sectionItem_col-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("merchant.notification_phone")) + "："
                      ),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.userInfo.merchant_basic_info.notification_phone
                        )
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { staticClass: "sectionItem_name" },
              [
                _c(
                  "el-col",
                  { staticClass: "sectionItem_col", attrs: { span: 12 } },
                  [
                    _c("span", { staticClass: "sectionItem_col-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("merchant.contract_effect_time")) + "："
                      ),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.userInfo.contract_validity_start) +
                        " " +
                        _vm._s(
                          _vm.userInfo.contract_validity_start
                            ? _vm.$t("merchant.to")
                            : "-"
                        ) +
                        " " +
                        _vm._s(_vm.userInfo.contract_validity_end)
                    ),
                  ]
                ),
                _c(
                  "el-col",
                  { staticClass: "sectionItem_col", attrs: { span: 12 } },
                  [
                    _c("span", { staticClass: "sectionItem_col-label" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("merchant.merchant_status")) + "："
                      ),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getMerchantStatusMap(_vm.userInfo.merchant_status)
                        )
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogImageVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogImageVisible = $event
            },
          },
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }